/* Le carrousel avant / apres, partage par la page B2B et les fiches personnalisees.
   ⚠️ LE RAIL DEFILE TOUT SEUL, ce script n'ajoute que le confort. `scroll-snap` fait le
   feuilletage au doigt, a la molette et au clavier ; s'il tombe, le carrousel reste utilisable.
   ⛔ LE COMPTEUR LIT LA POSITION, IL NE LA COMPTE PAS. Un compteur maison ment des qu'on fait
   glisser au doigt sans toucher les boutons, et c'est le geste le plus frequent sur mobile.
   ⛔ ET IL Y EN A PLUSIEURS PAR PAGE POSSIBLES : on arme CHAQUE `[data-agr]`, pas le premier.
   Une page qui en porterait deux n'en aurait anime qu'un, sans erreur pour le dire. */
(function () {
  function armer(boite) {
    var rail = boite.querySelector('[data-agr-rail]');
    if (!rail || !rail.firstElementChild) return;
    var cpt = boite.querySelector('[data-agr-cpt]');
    var prec = boite.querySelector('[data-agr-prec]');
    var suiv = boite.querySelector('[data-agr-suiv]');
    var total = rail.children.length;

    function pas() {
      var st = getComputedStyle(rail);
      var g = parseFloat(st.columnGap || st.gap || '0') || 0;
      return rail.firstElementChild.getBoundingClientRect().width + g;
    }
    function rang() { var p = pas(); return p > 0 ? Math.round(rail.scrollLeft / p) : 0; }
    /* ⛔ LE CARROUSEL BOUCLE, ET LES FLECHES NE S'ETEIGNENT PLUS (Adrien, 14/08/2026 : « le
       carrousel est infini et doit revenir a l'image 1 si on atteint la fin »). Une fleche
       desactivee a la derniere paire disait « c'est fini » : le visiteur qui a compris qu'il y
       a des exemples s'arretait la, alors qu'il en reste neuf a voir en repartant. Un bouton
       toujours cliquable ne cache rien : le compteur dit ou l'on est.
       ⚠️ MODULO SUR LES DEUX BORDS, PAS SEULEMENT A DROITE : reculer depuis la premiere paire
       doit mener a la derniere. `(i % total + total) % total` parce que le modulo de JavaScript
       garde le signe du dividende, et `-1 % 10` vaut `-1`, pas `9`.
       ⚠️ LE SAUT DE BOUT EN BOUT EST INSTANTANE. Un defilement doux sur dix paires traverse tout
       le rail sous les yeux : ca se lit comme une erreur, pas comme un retour au debut. */
    function maj() {
      var i = Math.min(total - 1, Math.max(0, rang()));
      if (cpt) cpt.textContent = (i + 1) + ' / ' + total;
    }
    function pousser(d) {
      var avant = rang();
      var i = (((avant + d) % total) + total) % total;
      var boucle = Math.abs(i - avant) > 1;
      rail.scrollTo({ left: i * pas(), behavior: boucle ? 'auto' : 'smooth' });
      maj();
    }
    if (prec) prec.addEventListener('click', function () { pousser(-1); });
    if (suiv) suiv.addEventListener('click', function () { pousser(1); });

    var attente = false;
    rail.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () { attente = false; maj(); });
    }, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  }
  function tout() {
    var l = document.querySelectorAll('[data-agr]');
    for (var i = 0; i < l.length; i += 1) {
      if (l[i].dataset.agrArme === '1') continue;
      l[i].dataset.agrArme = '1';
      armer(l[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  /* Le Personnalisateur reinjecte une section sans recharger la page : sans ce rappel, le
     carrousel d'un bloc qu'on vient de modifier reste inerte pendant l'edition. */
  document.addEventListener('shopify:section:load', tout);
})();
